(function () {
  'use strict';

  if (window.__boiProductPageInitRegistered) return;
  window.__boiProductPageInitRegistered = true;

  var shippingTimes = {
    italia: { default: 2, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    germania: { default: 3, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    francia: { default: 3, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    austria: { default: 3, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    'paesi-bassi': { default: 3, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    belgio: { default: 3, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    bulgaria: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    croazia: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    'repubblica-ceca': { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    danimarca: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    estonia: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    finlandia: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    grecia: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    lettonia: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    lituania: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    lussemburgo: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    malta: { default: 6, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    monaco: { default: 4, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    polonia: { default: 4, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    portogallo: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    romania: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    slovacchia: { default: 4, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    slovenia: { default: 4, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    spagna: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    svezia: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    europa: { default: 5, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    'regno-unito': { default: 8, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    svizzera: { default: 8, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    usa: { default: 15, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    canada: { default: 15, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    cipro: { default: 15, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    giappone: { default: 15, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    'hong-kong': { default: 15, special: { 'sped-2-5': 5, 'sped-4-10': 10 } },
    'extra-europa': { default: 15, special: { 'sped-2-5': 5, 'sped-4-10': 10 } }
  };

  var isoToShippingKey = {
    IT: 'italia', DE: 'germania', FR: 'francia', AT: 'austria', NL: 'paesi-bassi', BE: 'belgio',
    BG: 'bulgaria', HR: 'croazia', CZ: 'repubblica-ceca', DK: 'danimarca', EE: 'estonia',
    FI: 'finlandia', GR: 'grecia', LV: 'lettonia', LT: 'lituania', LU: 'lussemburgo',
    MT: 'malta', MC: 'monaco', PL: 'polonia', PT: 'portogallo', RO: 'romania', SK: 'slovacchia',
    SI: 'slovenia', ES: 'spagna', SE: 'svezia', GB: 'regno-unito', CH: 'svizzera', US: 'usa',
    CA: 'canada', CY: 'cipro', JP: 'giappone', HK: 'hong-kong', CO: 'extra-europa',
    AU: 'extra-europa', SG: 'extra-europa', CN: 'extra-europa', MY: 'extra-europa',
    NZ: 'extra-europa', ZA: 'extra-europa', NO: 'extra-europa', IS: 'extra-europa', IL: 'extra-europa'
  };

  function readConfig() {
    var node = document.getElementById('boi-product-config');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedIso(select) {
    if (!select || select.selectedIndex < 0) return null;
    var option = select.options[select.selectedIndex];
    return option && option.dataset.iso ? String(option.dataset.iso).toUpperCase() : null;
  }

  function stripLeadingFlagEmojis(text) {
    return String(text || '').replace(/^(?:[\u{1F1E6}-\u{1F1FF}]{2}\s*)+/gu, '').trim();
  }

  function refreshCountrySelect() {
    var select = document.getElementById('country-select');
    if (!select) return;
    Array.prototype.forEach.call(select.options, function (option) {
      var cleanLabel = option.dataset.cleanLabel || stripLeadingFlagEmojis(option.textContent);
      option.dataset.cleanLabel = cleanLabel;
      option.textContent = cleanLabel;
    });
    if (typeof window.addOptionFlags === 'function') window.addOptionFlags(select);
    if (typeof window.paintFlag === 'function') window.paintFlag(select);
  }

  function setSelectByIso(select, iso) {
    if (!select || !iso) return false;
    var normalizedIso = String(iso).toUpperCase();
    var target = Array.prototype.find.call(select.options, function (option) {
      return String(option.dataset.iso || '').toUpperCase() === normalizedIso;
    });
    if (!target) return false;
    var changed = select.value !== target.value;
    if (changed) select.value = target.value;
    if (select.id === 'country-select') refreshCountrySelect();
    if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function pageLocale() {
    var lang = document.documentElement.lang || 'it';
    if (lang.indexOf('de') === 0) return 'de-DE';
    if (lang.indexOf('fr') === 0) return 'fr-FR';
    if (lang.indexOf('en') === 0) return 'en-GB';
    return 'it-IT';
  }

  function ymdLocal(date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }

  function isWorkingDay(date, nonWorkingDays) {
    return date.getDay() !== 0 && date.getDay() !== 6 && nonWorkingDays.indexOf(ymdLocal(date)) === -1;
  }

  function getNextDeadline(now, nonWorkingDays) {
    var deadline = new Date(now);
    deadline.setHours(17, 0, 0, 0);
    if (!isWorkingDay(now, nonWorkingDays) || now >= deadline) {
      do {
        deadline.setDate(deadline.getDate() + 1);
        deadline.setHours(17, 0, 0, 0);
      } while (!isWorkingDay(deadline, nonWorkingDays));
    }
    return deadline;
  }

  function addWorkingDays(startDate, days, nonWorkingDays) {
    var date = new Date(startDate);
    while (days > 0) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date, nonWorkingDays)) days -= 1;
    }
    return date;
  }

  function resolveShippingDays(country, tags, inventory) {
    var rules = shippingTimes[country] || shippingTimes.europa;
    var quantity = Number(inventory) || 0;
    if (tags.indexOf('sped-4-10') !== -1) return rules.default + rules.special['sped-4-10'];
    if (tags.indexOf('sped-2-5') !== -1) return quantity > 100 ? rules.default : rules.default + rules.special['sped-2-5'];
    return rules.default;
  }

  function initShipping(config) {
    if (window.__productShippingInitDone) return;
    var select = document.getElementById('country-select');
    var container = document.getElementById('shipping-time-container');
    var result = document.getElementById('result');
    if (!select || !container || !result) return;
    window.__productShippingInitDone = true;

    var nonWorkingDays = ['2026-01-06', '2026-01-30'];
    var state = { deadline: null, iso: null, country: null };
    var tags = Array.isArray(config.productTags) ? config.productTags : [];

    function updateFreeShipping() {
      var message = document.getElementById('product-free-shipping-message');
      if (!message) return;
      if (state.iso === 'IT') {
        message.style.display = 'block';
        message.innerHTML = config.freeShippingItaly || '';
      } else if (['GB', 'CH', 'US', 'CA', 'CY', 'JP', 'HK'].indexOf(state.iso) !== -1) {
        message.style.display = 'none';
      } else {
        message.style.display = 'block';
        message.innerHTML = config.freeShippingEurope || '';
      }
    }

    function syncState() {
      state.iso = getSelectedIso(select) || 'IT';
      state.country = isoToShippingKey[state.iso] || 'extra-europa';
    }

    function render() {
      if (tags.indexOf('escluso') !== -1) {
        container.style.display = 'none';
        return;
      }
      container.style.display = 'block';
      state.deadline = getNextDeadline(new Date(), nonWorkingDays);
      var deliveryBase = new Date(state.deadline);
      deliveryBase.setHours(0, 0, 0, 0);
      var deliveryDate = addWorkingDays(deliveryBase, resolveShippingDays(state.country, tags, config.firstInventory), nonWorkingDays);
      var deliveryText = new Intl.DateTimeFormat(pageLocale(), {
        timeZone: 'Europe/Rome', weekday: 'long', month: 'long', day: 'numeric'
      }).format(deliveryDate);
      result.innerHTML = String(config.shippingTemplate || '')
        .replaceAll('[[delivery_date]]', deliveryText)
        .replaceAll('[[hours]]', '0')
        .replaceAll('[[minutes]]', '00');
      updateFreeShipping();
    }

    function tick() {
      var now = new Date();
      if (!state.deadline || now >= state.deadline || !isWorkingDay(now, nonWorkingDays)) render();
      var difference = Math.max(0, state.deadline - now);
      var totalMinutes = Math.floor(difference / 60000);
      var hours = result.querySelector('.dl-h');
      var minutes = result.querySelector('.dl-m');
      if (hours) hours.textContent = String(Math.floor(totalMinutes / 60));
      if (minutes) minutes.textContent = String(totalMinutes % 60).padStart(2, '0');
    }

    if (!select.querySelector('option[selected]') && config.marketIso) setSelectByIso(select, config.marketIso);
    syncState();
    render();
    tick();
    refreshCountrySelect();
    select.addEventListener('change', function () {
      syncState();
      render();
      tick();
      refreshCountrySelect();
    });
    window.setInterval(tick, 60000);
  }

  function initCountrySync() {
    var storageKey = 'shipping_country_iso';
    var productSelect = document.getElementById('country-select');
    if (!productSelect) return;

    function syncFromSideCart() {
      var sideSelect = document.getElementById('shipCountry');
      if (!sideSelect) return false;
      var iso = getSelectedIso(sideSelect);
      if (!iso) return false;
      localStorage.setItem(storageKey, iso);
      return setSelectByIso(productSelect, iso);
    }

    if (!syncFromSideCart()) {
      var savedIso = localStorage.getItem(storageKey);
      if (savedIso) setSelectByIso(productSelect, savedIso);
    }

    document.addEventListener('change', function (event) {
      var element = event.target;
      if (!(element instanceof HTMLSelectElement)) return;
      if (element.id === 'shipCountry') {
        var sideIso = getSelectedIso(element);
        if (sideIso) {
          localStorage.setItem(storageKey, sideIso);
          setSelectByIso(productSelect, sideIso);
        }
      } else if (element.id === 'country-select') {
        var productIso = getSelectedIso(element);
        if (productIso) localStorage.setItem(storageKey, productIso);
      }
    });

    document.addEventListener('cart:updated', syncFromSideCart);
    if (!document.getElementById('shipCountry')) window.setTimeout(syncFromSideCart, 800);
  }

  function initVariantSelectors(config) {
    if (!window.jQuery || !window.Shopify || !Shopify.OptionSelectors || !document.getElementById('productSelect')) return;
    var $ = window.jQuery;
    window.selectCallback = function (variant, selector) {
      if (!window.timber || typeof window.timber.productPage !== 'function') return;
      window.timber.productPage({
        money_format: config.moneyFormat,
        variant: variant,
        selector: selector,
        translations: config.translations
      });
    };
    new Shopify.OptionSelectors('productSelect', {
      product: config.product,
      onVariantSelected: window.selectCallback,
      enableHistoryState: true
    });
    if (config.enableLinkedOptions && config.product.available && config.product.options.length > 1 && Shopify.linkOptionSelectors) {
      Shopify.linkOptionSelectors(config.product);
    }
    if (config.singleOptionLabel) {
      $('.selector-wrapper:eq(0)').prepend($('<label>', { for: 'productSelect-option-0', text: config.singleOptionLabel }));
    }
    if (config.hideDefaultVariant) $('.selector-wrapper, .selector-wrapper-secton').hide();
    (config.firstAvailableOptions || []).forEach(function (option, index) {
      $('.single-option-selector:eq(' + index + ')').val(option).trigger('change');
    });
    $('.product-single .single-option-selector').each(function () {
      if (!$(this).parent().hasClass('selector-arrow')) $(this).wrap('<div class="selector-arrow">');
    });
  }

  function initFoodIcons(config) {
    var container = document.getElementById('abbinamento');
    if (!container || !Array.isArray(config.foodIcons)) return;
    config.foodIcons.forEach(function (url) {
      var image = document.createElement('img');
      image.src = url;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 40;
      image.height = 40;
      image.style.marginBottom = '5%';
      image.style.marginRight = '10px';
      container.appendChild(image);
    });
  }

  function initNavigation() {
    document.addEventListener('click', function (event) {
      var reviewTrigger = event.target.closest && event.target.closest('[data-boi-review-target]');
      if (reviewTrigger) {
        var reviewTarget = document.querySelector(reviewTrigger.getAttribute('data-boi-review-target'));
        if (!reviewTarget) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        reviewTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        var focusTarget = reviewTarget.querySelector('.jdgm-rev-widg__title') || reviewTarget;
        if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
        window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
        return;
      }

      var descriptionTrigger = event.target.closest && event.target.closest('.scroll[target]');
      if (!descriptionTrigger) return;
      var descriptionTarget = document.getElementById(descriptionTrigger.getAttribute('target'));
      if (descriptionTarget) descriptionTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    if (window.__boiProductPageInitDone) return;
    var config = readConfig();
    if (!config) return;
    window.__boiProductPageInitDone = true;
    window.currentProductId = config.productId;
    window.currentProductType = config.productType;
    window.currentProductTags = config.productTags;

    var desktopSticky = document.querySelector('.boi-desktop-sidebar-sticky');
    if (desktopSticky) desktopSticky.classList.toggle('left-sidebar-sticky', window.matchMedia('(min-width: 769px)').matches);

    initVariantSelectors(config);
    initShipping(config);
    initCountrySync();
    initFoodIcons(config);
    initNavigation();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
